module.exports = {"id":"212470","name":"Maximiliano Rodriguez","rating":"71","photo":"./data/images/photos/0/212470.png","club":{"name":"San Juan","logo":"./data/images/clubs/SanJuan.png"},"positions":["MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximilianoRodriguez0.json
// module id = 2954
// module chunks = 0